<template>
  <div class="banner-od-accepted">
    <p class="text">Your on-demand consultation has been accepted.</p>

    <div class="buttons">
      <smd-btn class="accept-btn" clean @click="view">View</smd-btn>
    </div>
  </div>
</template>

<script>
  import Routes from '@/router/routes';

  export default {
    name: "banner-od-accepted",
    props: {
      bookingId: {type: String, required: true},
    },
    methods: {
      view() {
        this.$router.push({
          name: Routes.ONDEMAND_ROOT,
          params: {bookingID: this.bookingId},
        });
      },
    },
  }
</script>

<style lang="scss">
  .banner-od-accepted {
    background-color: color(green, messenger);
    display: inline-flex;
    padding: space(s) space(m);
    justify-content: center;
    flex-wrap: wrap;
    color: color(white, brand);
    border-radius: radius(medium);
    @include box-shadow(shadow);

    .text {
      @include space-me($prop: margin, $r: s);
      align-self: center;

      @include responsive(mobile) {
        padding: space(xs);
      }
    }

    button {
      @include font-style(Body1);

      &.accept-btn, .accept-btn:hover {
        color: color(white, brand);
      }

      &.later-btn, .later-btn:hover {
        color: color(dark, brand);
      }
    }
  }
</style>